import React, { Component } from "react";
import { connect } from "react-redux";

import PreviewComponent from "./PreviewComponent";

class PreviewContainer extends Component {
  render() {
    return <PreviewComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({
  hubPreferences: state.auth.navCommunity.hubPreferences
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviewContainer);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Preview/index.js